export class CampaignMonitor {

  form;
  form_id;
  successMessage;
  errorMessage;

  constructor($selector) {
    this.form = $selector;
    this.successMessage = $selector.find('.success');
    this.errorMessage = $selector.find('.error');
  }

  init = function () {
    const self = this;
    
    this.successMessage.hide();
    this.errorMessage.hide();
    const form = this.form;
  
    // On form submit.
    form.submit(function (evt) {
      let form_id = form.attr('data-id');
      let data = $(this).serialize();
      // Disable default form submit.

      evt.preventDefault();

      // Get e-mail value.
      const email = $('input[type=email]', form).val();

      if (!email) { return; }

      // Build request data for tokenRequest.
      const request_data = "email=" + encodeURIComponent(email) + "&data=" + form_id;

      // Prepare tokenRequest.
      const tokenRequest = new XMLHttpRequest();
      tokenRequest.open('POST', 'https://createsend.com//t/getsecuresubscribelink', true);
      tokenRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      tokenRequest.send(request_data);

      // Ready state.
      tokenRequest.onreadystatechange = function() {
        if (this.readyState === 4) {
          if (this.status === 200) {
            // Having token and new submit url we can create new request to subscribe a user.
            const subscribeRequest = new XMLHttpRequest();
            subscribeRequest.open('POST', this.responseText, true);
            subscribeRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            subscribeRequest.send(data);
            // On ready state call response function.
            subscribeRequest.onreadystatechange = function() {
              self.response(subscribeRequest);
            }
          } else {
            self.response(tokenRequest);
          }
        }
      }
    });
  }

  // Handle ajax response.
  response = function(request) {
    let self = this;
    if (request.readyState === 4) {
      if (request.status === 200) {
        // redirect to thank you page
        self.successMessage.show('slow');
      } else {
        self.errorMessage.show('slow');
      }

      let form = self.form;
      let submitText = form.find('[data-submit-text]');
      let submittingText = form.find('[data-submitting-text]');
      let btn = form.find('button[type="submit"]');
      submittingText.addClass('hide');
      submitText.show();
      btn.prop('disabled', false);

      setTimeout(function(){
        self.successMessage.hide('slow');
        self.errorMessage.hide('slow');
      },3000);
    }
  }
}

(function() {
  (new CampaignMonitor($('[data-form-createsend]'))).init();
})();
